import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ApiService } from "./api.service";

export interface AdminThemeFieldDefinition {
  key: string;
  label: string;
  usedFor: string;
  defaultValue: string;
}

export interface AdminTheme {
  id: number;
  themeName: string;
  portal?: string;
  primaryColor: string;
  secondaryColor: string;
  backgroundColor: string;
  surfaceColor: string;
  textPrimaryColor: string;
  textSecondaryColor: string;
  successColor: string;
  warningColor: string;
  errorColor: string;
  infoColor: string;
  sidebarBackground: string;
  sidebarTextColor: string;
  headerBackground: string;
  headerTextColor: string;
  logoUrl?: string | null;
  siteLogoUrl?: string | null;
  homeLetterLogoUrl?: string | null;
  isActive?: boolean;
  isActiveLabel?: string;
  tokens: Record<string, string>;
  fields: AdminThemeFieldDefinition[];
  createdBy?: number | null;
  createdByName?: string;
  createdOn: string;
  updatedOn: string;
}

export interface AdminThemeHistoryItem {
  id: number;
  themeName: string;
  isActive: boolean;
  isActiveLabel: string;
  createdBy?: number | null;
  createdByName: string;
  createdOn: string;
}

export type SaveAdminThemeRequest = Omit<
  AdminTheme,
  | "id"
  | "tokens"
  | "fields"
  | "isActive"
  | "isActiveLabel"
  | "createdBy"
  | "createdByName"
  | "createdOn"
  | "updatedOn"
>;

export interface SaveAdminThemeResponse {
  theme: AdminTheme;
  changed: boolean;
  message: string;
}

export interface UploadAdminThemeLogoResponse {
  saveResult: SaveAdminThemeResponse;
  logoUrl: string;
  assetKey?: string | null;
  storedFileName: string;
}

@Injectable({
  providedIn: "root",
})
export class AdminThemeService {
  constructor(private api: ApiService) {}

  getActiveTheme(): Observable<AdminTheme> {
    return this.api.getPath<AdminTheme>("admin-theme");
  }

  getHistory(): Observable<AdminThemeHistoryItem[]> {
    return this.api.getPath<AdminThemeHistoryItem[]>("admin-theme/history");
  }

  saveTheme(request: SaveAdminThemeRequest): Observable<SaveAdminThemeResponse> {
    return this.api.putPath<SaveAdminThemeResponse>("admin-theme", request);
  }

  uploadLogo(file: File): Observable<UploadAdminThemeLogoResponse> {
    const formData = new FormData();
    formData.append("file", file, file.name);
    return this.api.postPath<UploadAdminThemeLogoResponse>("admin-theme/logo", formData);
  }
}
